import { OktaAuth, type OktaAuthOptions } from '@okta/okta-auth-js';

const issuer = import.meta.env.VITE_OKTA_ISSUER;
const clientId = import.meta.env.VITE_OKTA_CLIENT_ID;
const configuredRedirectUri = import.meta.env.VITE_OKTA_REDIRECT_URI;

function resolveRedirectUri(): string {
  if (configuredRedirectUri) return configuredRedirectUri;
  if (typeof window !== 'undefined') return `${window.location.origin}/login/callback`;
  return 'http://localhost:5173/login/callback';
}

const missing: string[] = [];
if (!issuer) missing.push('VITE_OKTA_ISSUER');
if (!clientId) missing.push('VITE_OKTA_CLIENT_ID');

/**
 * Dev mode without an Okta app: bypass the gate so contributors can preview
 * decks locally without provisioning Okta. In production builds the missing
 * config still raises an error splash.
 */
export const isDevAuthBypass: boolean = import.meta.env.DEV && missing.length > 0;

export const oktaConfigError: string | null =
  missing.length > 0 && !isDevAuthBypass
    ? `Missing Okta config: ${missing.join(', ')}. Copy .env.example to .env.local and fill in values from the Okta admin console.`
    : null;

const options: OktaAuthOptions = {
  issuer: issuer ?? '',
  clientId: clientId ?? '',
  redirectUri: resolveRedirectUri(),
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  responseType: ['code'],
  postLogoutRedirectUri:
    typeof window !== 'undefined' ? window.location.origin : undefined,
};

export const oktaAuth: OktaAuth | null =
  missing.length > 0 ? null : new OktaAuth(options);
